import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import smiERR from "../../../../assets/smi-kudzu-images/smi_mobile_error.png"
import { appTheme } from '../../../../helpers/utils/Utils';

const ExistingErrorModal = ({ onLoginClick, onTryAgainClick, hideTryAgain , onContinueClick , showContinue}) => {
    const { t } = useTranslation()
    const isFromSmiOne = useSelector((state) => state.fromSmiOne);
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);  
    const appThemeData = appTheme(signUpkudzuPlusTrue)

    return (
        <div className="my-10 w-full relative">
            <div className={`md:w-[450px] sm:w-[294px] xsm:w-[240px] w-[240px] flex flex-col justify-start gap-5 mb-10`}>
                <img
                    src={smiERR}
                    alt="complete"
                    className='lg:w-[120px] md:w-[180px] sm:w-[92px] w-[180px] ml-0 md:ml-[134px]'
                />
                <div className='lg:pt-20 md:pt-18 sm:pt-10 pt-16 w-full'>


                    <button
                        //style={{ backgroundColor: '#2965FB' }}
                         style={{ color: '#2965FB' }}
                        className=' lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] w-full lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] text-white font-hanken-grotesk font-bold leading-[16px] border-[#2965FB] border-[2.5px] focus:border-[#2965FB] focus:border-[#3px]'
                        tabIndex={0}
                        id='btn1AccRef'
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                onLoginClick()
                                event.stopPropagation();
                            }
                        }}
                        onClick={(event) => { event.target.style.opacity = 0.8; onLoginClick(); setTimeout(() => { event.target.style.opacity = 1; }, 200); }}>{t("login")}</button>
                    {hideTryAgain ? (<>
                    </>) : (<>
                        <button
                            tabIndex={0}
                            id='btn2Ref'
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    onTryAgainClick()
                                    event.stopPropagation();
                                }
                            }}
                            className={` w-full mt-5 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] `}
                            style={{ color: '#2965FB' }}
                            onClick={(event) => {
                                event.target.style.opacity = 0.8;
                                onTryAgainClick()
                            }}>{t("try_again1")}</button>
                    </>)}



                </div>

            </div>
           {showContinue &&
            <div className={`absolute  ${isFromSmiOne ? 'sm:right-[-4rem]' : 'sm:right-[0rem]'} xsm:right-[0rem] right-[-1rem] `}>
                {/*  md:bottom-20 sm:bottom-16 bottom-8 xsm:bottom-14 */}
                <button
                    type="button"
                    className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] 
          text-[14px]
           text-[var(--twofac-modal-btn-clr-disabled)] cursor-pointer flex items-center"
                  onClick={onContinueClick}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                onContinueClick();
                            }
                        }}
                >
                    {t('continue')}
                    <img
                     src={appThemeData.SignupNextArrow}
                        className={'md:w-[17px] sm:w-[11px] md:h-[17px] sm:h-[11px] w-[12px] h-[12px]'}

                        alt="Arrow"
                    />
                </button>
            </div>
           }
           
        </div>
    )
}

export default ExistingErrorModal